var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66455 1.66602V4.99827",
    stroke: "#6B7280",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3291 1.66602V4.99827",
    stroke: "#6B7280",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8281 3.33228H4.16515C3.24497 3.33228 2.49902 4.07823 2.49902 4.9984V16.6613C2.49902 17.5815 3.24497 18.3274 4.16515 18.3274H15.8281C16.7482 18.3274 17.4942 17.5815 17.4942 16.6613V4.9984C17.4942 4.07823 16.7482 3.33228 15.8281 3.33228Z",
    stroke: "#6B7280",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49902 8.33057H17.4942",
    stroke: "#6B7280",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon02);
export default __webpack_public_path__ + "static/media/icon02.beffa2b7500feff68e16dc78057704af.svg";
export { ForwardRef as ReactComponent };